const DEFAULT_ALLERGENS = [
  [1, 'Glutine', 'Gluten'],
  [2, 'Crostacei', 'Crustaceans'],
  [3, 'Uova', 'Eggs'],
  [4, 'Pesce', 'Fish'],
  [5, 'Arachidi', 'Peanuts'],
  [6, 'Soia', 'Soy'],
  [7, 'Latte e derivati', 'Milk and dairy'],
  [8, 'Frutta a guscio', 'Nuts'],
  [9, 'Sedano', 'Celery'],
  [10, 'Senape', 'Mustard'],
  [11, 'Semi di sesamo', 'Sesame seeds'],
  [12, 'Anidride solforosa e solfiti', 'Sulphites'],
  [13, 'Lupini', 'Lupin'],
  [14, 'Molluschi', 'Molluscs'],
].map(([n, it, en]) => ({ n, name: { it, en } }));

export const getAllergens = (menu) => (Array.isArray(menu?.allergens) ? menu.allergens : DEFAULT_ALLERGENS);

export const getExtras = (menu) => ({
  items: Array.isArray(menu?.extras?.items) ? menu.extras.items : [],
  sections: Array.isArray(menu?.extras?.sections) ? menu.extras.sections : [],
});

export const parseAllergens = (str) =>
  String(str || '').split(/[^0-9]+/).filter(Boolean).map(Number);

export const formatAllergens = (nums) => [...new Set(nums)].sort((a, b) => a - b).join(',');
